import { render, staticRenderFns } from "./cdmreject.vue?vue&type=template&id=3077e19a&"
import script from "./cdmreject.vue?vue&type=script&lang=js&"
export * from "./cdmreject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports